import { BuscaCidadaoListagemProblemasFragment, GrupoCondicaoEnum, SituacaoProblema } from 'graphql/types.generated'

import {
  BuscaCidadaoQueryResultModel,
  CidadaoListagemDiabetesQueryModel,
  CidadaoListagemHipertensaoQueryModel,
} from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

type CidadaoListagemQueryModel = CidadaoListagemDiabetesQueryModel | CidadaoListagemHipertensaoQueryModel
type BuscaCidadaoListagemProblema = BuscaCidadaoListagemProblemasFragment['problemas'][0]

/**
 * @param row
 * @param grupoCondicao
 * @returns `true` se contém algum problema com situação ativa e ciap ou cid do grupo condição informado
 *           ou se nao for da lista tematica correta, `false` caso contrário.
 */
export function hasProblemaAtivoDoGrupoCondicao(
  row: BuscaCidadaoQueryResultModel,
  grupoCondicao: GrupoCondicaoEnum
): boolean {
  if (!grupoCondicao) return true

  const problemas = (row as CidadaoListagemQueryModel).cidadao?.prontuario?.problemas || []
  if (problemas.isEmpty()) return false

  return problemas.some(isProblemaAtivoDoGrupoCondicao(grupoCondicao))
}

const isProblemaAtivoDoGrupoCondicao = (grupoCondicao: GrupoCondicaoEnum) => ({
  ultimaEvolucao,
  ciap,
  cid10,
}: BuscaCidadaoListagemProblema): boolean => {
  const isAtivo = ultimaEvolucao?.situacao === SituacaoProblema.ATIVO
  const isCiapOfGrupoCondicao = ciap?.gruposCondicao?.some(({ grupo }) => grupo === grupoCondicao)
  const isCid10OfGrupoCondicao = cid10?.gruposCondicao?.some(({ grupo }) => grupo === grupoCondicao)

  return isAtivo && (isCiapOfGrupoCondicao || isCid10OfGrupoCondicao)
}
